import { useState } from 'react'

import DialogTitle from '@components/mui/DialogTitle'
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Stack,
	TextField,
	Typography,
} from '@mui/material'
import { DialogProps } from '@toolpad/core/useDialogs'

export default function SkipTasksDialog({ open, onClose }: DialogProps<void, boolean>) {
	const [text, setText] = useState('')

	return (
		<Dialog
			open={open}
			onClose={() => onClose(false)}
			sx={{
				'& .MuiDialog-container': {
					alignItems: 'flex-start',
					mt: '5rem',
				},
				'& .MuiDialog-paper': {
					width: '28rem',
				},
			}}
		>
			<DialogTitle onClose={() => onClose(false)}>Skip Action Center tasks</DialogTitle>
			<DialogContent dividers>
				<Stack spacing={2}>
					<Typography variant="subtitle1" textAlign="center">
						Are you sure you want to skip completing the tasks for this basket?
					</Typography>
					<Typography variant="body2" fontWeight="bold" color="error" textAlign="center">
						This may result in incorrect matches and savings!
					</Typography>
					<Typography variant="body2" textAlign="center">
						Type &quot;skip tasks&quot; below to continue.
					</Typography>
					<TextField
						autoFocus
						fullWidth
						size="small"
						multiline
						value={text}
						placeholder="skip tasks"
						onChange={(e) => setText(e.target.value)}
					/>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button variant="text" color="secondary" onClick={() => onClose(false)}>
					Cancel
				</Button>
				<Button variant="contained" onClick={() => onClose(true)} disabled={text !== 'skip tasks'}>
					Skip Tasks
				</Button>
			</DialogActions>
		</Dialog>
	)
}
